import { Component, Input, OnInit } from "@angular/core";
import { LoadingController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ChiaveConfig } from "src/app/models/configurazioni/ChiaveConfig";
import { Rilevazione } from "src/app/models/rilevazione-presenze/rilevazione";
import { ConfigService } from "src/app/services/config-service/config-service";
import { UtilityService } from "src/app/services/utility.service";


@Component({
    selector: 'app-inserisci-conferma',
    templateUrl: './inserisci-conferma.component.html',
    styleUrls: ['./inserisci-conferma.component.scss'],
    standalone: false
})
export class InserisciConfermaComponent implements OnInit {

  @Input() rilevazione: Rilevazione;

  defaultTime: string;

  constructor(
    private modalCtrl: ModalController,
    private utilityService: UtilityService,
    private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    private configService: ConfigService
  ) {

  }

  async ngOnInit() {
    this.defaultTime = this.utilityService.setLocalTime(this.rilevazione.richiestaConferma.istanteRichiesta).toISOString();
  } 

  async annulla() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }

  async changeDefault(e) {
    const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('label.richiestaincorso')
    });
    loader.present();
    this.defaultTime = e.detail.value;
    loader.dismiss();
  }

  async checkData(data) {
    let defaultTime;
    if(this.defaultTime.includes('+')) {
      defaultTime = this.utilityService.setLocalTime(new Date(this.defaultTime)).getTime();
    }
    else {
      defaultTime = new Date(this.defaultTime).getTime();
    }

    let startRil = this.utilityService.setLocalTime(new Date(this.rilevazione.istanteCreazione).setSeconds(0,0)).getTime();
    let endRil = this.utilityService.setLocalTime(new Date(this.rilevazione.chiusura).setSeconds(0,0)).getTime();
    let chiusuraAnticipata = this.utilityService.setLocalTime(new Date(this.rilevazione.chiusuraAnticipata).setSeconds(0,0)).getTime();
    let avvioVerifica = this.utilityService.setLocalTime(new Date(this.rilevazione.richiestaConferma.istanteRichiesta).setSeconds(0,0)).getTime();
    let secondiVerifica = this.configService.getConfigurazione(ChiaveConfig.SECONDI_VERIFICA_PRESENZE) * 1000;

    if(defaultTime >= startRil && (defaultTime <= chiusuraAnticipata || defaultTime <= endRil)) {
      if(defaultTime >= avvioVerifica && defaultTime <= (avvioVerifica + secondiVerifica)) {
        await this.modalCtrl.dismiss(data, 'cancel');
      }
      else {
        this.utilityService.presentToast(this.translateService.instant('inserisci-conferma.label.error'));
      }
    }
    else {
      this.utilityService.presentToast(this.translateService.instant('inserisci-conferma.label.error'));
    }

  }

  async confirm() {
    const data = {defaultTime: this.defaultTime};
    this.checkData(data);
    
  }

}